import styled from 'styled-components';

export const Container = styled.div`
  .list-highlight {
    margin-bottom: 0;
    list-style-type: disc;
    list-style-position: inside;
  }

  .bidding {
    border-top-left-radius: 0;

    &-keyword {
      background: ${(props) => props.theme.$keyword};
    }

    &.bidding_selected {
      .bidding-bg-header {
        border-top-left-radius: 0 !important;
      }

      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      &::before {
        content: '';
        width: 7px;
        height: 100%;
        background: ${(props) => props.theme.$primary_green};
        position: absolute;
        left: -7px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
    }

    &-info {
      &-icon {
        font-size: 15px;
      }

      &-title {
        color: ${(props) => props.theme.$dark};
        font-weight: bold;
      }

      &-state {
        background: ${(props) => props.theme.$info};
        color: ${(props) => props.theme.$white};
        padding: 3px 5px;
      }

      a:hover {
        cursor: pointer;
      }
    }
  }

  .item-highlight {
    em {
      background: ${(props) => props.theme.$keyword};
      padding: 0.2em;
    }
  }

  .highlight {
    background: ${(props) => props.theme.$keyword};
    padding: 0.2em;
  }

  @media print {
    @page {
      margin: 0.5cm;
    }
    .card.bidding {
      margin: 30px 15px 0 15px;
    }
    .bidding.bidding_selected::before {
      display: none;
    }

    .bidding-bg-header {
      background: ${(props) => props.theme.$white};

      .text-white {
        color: ${(props) => props.theme.$black} !important;
      }
    }

    .bidding-info-icon {
      display: none;
    }
  }
`;

export const Text = styled.div`
  mark {
    background: ${(props) => props.theme.$keyword};
  }
`;
